export type Salutation =
  | 'Mr'
  | 'Mrs'
  | 'Miss'
  | 'Ms'
  | 'Mx'
  | 'Dr'
  | 'Prof'
  | 'Rev'

// Salutation lists are intentionally ordered differently for Users vs Patients
// Users: more doctors/professionals expected
export const USER_SALUTATIONS: Salutation[] = [
  'Dr',
  'Prof',
  'Mr',
  'Mrs',
  'Ms',
  'Miss',
  'Mx',
  'Rev',
]

// Patients: everyday titles first, still allowing clinical/professional salutations
export const PATIENT_SALUTATIONS: Salutation[] = [
  'Ms',
  'Mr',
  'Mrs',
  'Miss',
  'Mx',
  'Dr',
  'Prof',
  'Rev',
]


